import axios from 'axios'

const HTTP = axios.create({
  // baseURL: 'http://localhost:8000'
  baseURL: 'http://cintorin.skymaps.cz:8000'
})

export { HTTP }



// WEBPACK FOOTER //
// ./src/common/http.js